<template>
    <div class="w-[260px] min-w-[260px] max-w-[260px] bg-white p-4 box-border rounded-2xl ">
        <p class="font-medium select-none">
            Tài xế
        </p>

        <div
            v-if="CFullName"
            class="flex mt-3 w-full max-w-full overflow-hidden text-ellipsis">
            <div class="min-w-16 w-16">
                <hts-avatar
                    :src="CAvatarUrl"
                    size="small" />
            </div>
            <div class="w-full">
                <h3 class="text-main-text h-[26px] leading-[26px] m-0 p-0 mt-[8px] select-none  whitespace-nowrap">
                    <hts-tooltip placement="top">
                        <template #reference>
                            {{ CFullName }}
                        </template>
                        <div>
                            {{ CFullName }}
                        </div>
                    </hts-tooltip>
                </h3>
                <hts-status-dot
                    module="driver"
                    :status="CStatus"/>

                <div
                    v-if="CPhone"
                    class="flex font-medium justify-start items-center mt-3">
                    <div class="avatar">
                        <div
                            class="w-8 p-1 mr-2 rounded-full bg-orange-500 cursor-pointer"
                            @click="makeCall">
                            <hi-phone-icon
                                class="text-white" />
                        </div>
                    </div>
                    <span>
                        {{ CPhone }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
const defaultAvatarUrl = ref('/assets/default-avatar.png')

const props = defineProps({
  journey: {
    type: Object,
    required: true
  }
})

const { journey } = toRefs(props)

const CAvatarUrl = computed(() => {
  return journey.value?.vehicle?.driver?.companyUser?.avatar || defaultAvatarUrl.value
})

const CFullName = computed(() => {
  return journey.value?.vehicle?.driver?.fullName || journey.value?.vehicleTemp?.driver?.fullName || ''
})

const CStatus = computed(() => {
  return journey.value?.vehicle?.driver?.status || journey.value?.vehicleTemp?.driver?.status || ''
})

const CPhone = computed(() => {
  if (journey.value?.vehicle?.driver) {
    return journey.value.vehicle.driver.phone.code + journey.value.vehicle.driver.phone.phone
  }

  if (journey.value?.vehicleTemp?.driver) {
    return journey.value.vehicleTemp.driver.phone.code + journey.value.vehicleTemp.driver.phone.phone
  }

  return ''
})

const makeCall = () => {
  if (!CPhone.value) {
    return
  }

  window.open(`tel:${CPhone.value}`)
}
</script>
